import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	summaryTextareaLabel: {
		id: 'issue-field-summary.edit.summary-textarea-label',
		defaultMessage: 'Summary',
		description: 'aria-label of the summary textarea',
	},
});
